const initialState = {
  loading: false,
  saving: false,
  error: "",
  selectedCatalogId: "financial_planning",
  catalogs: {},
  versionBatches: [],
  notesByCatalog: {
    financial_planning: "",
    mortgage_protection: "",
  },
  editorOpen: false,
  editorMode: "create",
  selectedCategoryId: "",
  selectedItem: null,
};

export const chargesInitialState = initialState;

const sortCategories = (categories = []) =>
  [...categories].sort(
    (a, b) => (a.displayOrder || 999) - (b.displayOrder || 999),
  );

const sortItems = (items = []) =>
  [...items].sort(
    (a, b) =>
      (a.displayOrder || 999) - (b.displayOrder || 999) ||
      (a.name || "").localeCompare(b.name || ""),
  );

const chargesReducer = (state, action) => {
  switch (action.type) {
    case "SET_LOADING":
      return {
        ...state,
        loading: action.payload,
      };

    case "SET_SAVING":
      return {
        ...state,
        saving: action.payload,
      };

    case "SET_ERROR":
      return {
        ...state,
        error: action.payload || "",
      };

    case "SET_SELECTED_CATALOG":
      return {
        ...state,
        selectedCatalogId: action.payload,
      };

    case "SET_CATALOGS": {
      const normalized = {};

      (action.payload || []).forEach((catalog) => {
        normalized[catalog.id] = {
          ...catalog,
          categories: sortCategories(catalog.categories || []).map((cat) => ({
            ...cat,
            items: sortItems(cat.items || []),
          })),
        };
      });

      return {
        ...state,
        catalogs: normalized,
      };
    }

    case "SET_VERSION_BATCHES":
      return {
        ...state,
        versionBatches: action.payload || [],
      };

    case "OPEN_EDITOR":
      return {
        ...state,
        editorOpen: true,
        editorMode: action.payload.mode || "create",
        selectedCategoryId: action.payload.categoryId || "",
        selectedItem: action.payload.item || null,
      };

    case "CLOSE_EDITOR":
      return {
        ...state,
        editorOpen: false,
        editorMode: "create",
        selectedCategoryId: "",
        selectedItem: null,
      };

    case "UPSERT_ITEM_LOCAL": {
      const { catalogId, categoryId, item } = action.payload;
      const catalog = state.catalogs[catalogId];
      if (!catalog) return state;

      return {
        ...state,
        catalogs: {
          ...state.catalogs,
          [catalogId]: {
            ...catalog,
            categories: catalog.categories.map((category) => {
              if (category.id !== categoryId) return category;

              const exists = (category.items || []).some(
                (existing) => existing.id === item.id,
              );

              const nextItems = exists
                ? category.items.map((existing) =>
                    existing.id === item.id
                      ? { ...existing, ...item }
                      : existing,
                  )
                : [...(category.items || []), item];

              return {
                ...category,
                items: sortItems(nextItems),
              };
            }),
          },
        },
      };
    }

    case "SET_NOTES_BY_CATALOG":
      return {
        ...state,
        notesByCatalog: {
          financial_planning: "",
          mortgage_protection: "",
          ...(action.payload || {}),
        },
      };

    case "UPDATE_NOTE_FOR_CATALOG":
      return {
        ...state,
        notesByCatalog: {
          ...state.notesByCatalog,
          [action.payload.catalogId]: action.payload.value,
        },
      };

    case "SET_CURRENT_VERSION_ID":
      return {
        ...state,
        currentVersionId: action.payload,
      };

    case "REMOVE_ITEM_LOCAL": {
      const { catalogId, categoryId, itemId } = action.payload;
      const catalog = state.catalogs[catalogId];
      if (!catalog) return state;

      return {
        ...state,
        catalogs: {
          ...state.catalogs,
          [catalogId]: {
            ...catalog,
            categories: catalog.categories.map((category) =>
              category.id === categoryId
                ? {
                    ...category,
                    items: (category.items || []).filter(
                      (item) => item.id !== itemId,
                    ),
                  }
                : category,
            ),
          },
        },
      };
    }

    default:
      return state;
  }
};

export default chargesReducer;
